import { Button } from '@mui/material'
import React from 'react'

const CustemButton = ({sx, id, text, disabled, variant, onClick, type, value, name, onChange, backgroundColor}) => {
  return (
    <Button onChange={onChange} id={id} type={type} name={name} variant={variant} value={value} disabled={disabled} onClick={onClick} sx={{textTransform: 'none',  "&:hover": {backgroundColor:{backgroundColor}}, backgroundColor:{backgroundColor}, boxShadow:'0px 4px 6px #e1e1e1',...sx}} >{text}</Button>
  )
}

export default CustemButton